"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _MediaCreator = _interopRequireDefault(require("./MediaCreator"));
var _EditMenu = _interopRequireDefault(require("./EditMenu"));
var _MediaObject = _interopRequireDefault(require("./MediaObject"));
var _icon = _interopRequireDefault(require("../icon"));
var _helpers = require("./helpers");
var _StyledMedia = require("./StyledMedia.style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Media = /*#__PURE__*/function (_Component) {
  function Media(props) {
    var _this;
    _classCallCheck(this, Media);
    _this = _callSuper(this, Media, [props]);
    _defineProperty(_this, "handleNewMediaCreator", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        disabled = _this$props.disabled;
      var mediaLengthReached = R.length(data) >= 3;
      if (!mediaLengthReached && !disabled) {
        _this.setState(function (prevState) {
          return {
            newMediaCreatorOpen: !prevState.newMediaCreatorOpen,
            creatorOpen: prevState.newMediaCreatorOpen ? false : prevState.creatorOpen,
            mediaIndex: R.isNil(data) ? [] : R.length(data)
          };
        });
      }
    });
    _defineProperty(_this, "handleMediaCreatorPopup", function (mediaIndex) {
      _this.setState(function (prevState) {
        return {
          creatorOpen: !prevState.creatorOpen,
          editMenuOpen: !prevState.creatorOpen === true ? false : prevState.editMenuOpen,
          mediaIndex: mediaIndex,
          newMediaCreatorOpen: !prevState.creatorOpen === true ? false : prevState.newMediaCreatorOpen
        };
      });
    });
    _defineProperty(_this, "onMouseEnterHandler", function (index) {
      _this.setState(function (prevState) {
        return {
          showMoreIconIndex: prevState.creatorOpen ? null : index
        };
      });
    });
    _defineProperty(_this, "onMouseLeaveHandler", function () {
      _this.setState({
        showMoreIconIndex: null
      });
    });
    _defineProperty(_this, "handleMediaEditMenu", function (mediaIndex) {
      _this.setState(function (prevState) {
        return {
          editMenuOpen: !prevState.editMenuOpen,
          creatorOpen: !prevState.editMenuOpen === true ? false : prevState.creatorOpen,
          mediaIndex: R.isNil(mediaIndex) ? prevState.mediaIndex : mediaIndex
        };
      });
    });
    _defineProperty(_this, "onCreateLink", function (newLink) {
      var mediaIndex = _this.state.mediaIndex;
      var mediaList = R.isNil(_this.props.data) ? [] : _this.props.data;
      var isNewMediaItem = mediaIndex + 1 > R.length(mediaList) || R.isNil(mediaIndex);
      var updatedMediaList = isNewMediaItem ? [].concat(_toConsumableArray(mediaList), [newLink]) : mediaList.map(function (mediaItem, index) {
        if (index === mediaIndex) {
          return _objectSpread({}, newLink);
        }
        return mediaItem;
      });
      _this.setState({
        mediaIndex: null
      }, function () {
        _this.props.onChange(updatedMediaList);
      });
    });
    _defineProperty(_this, "onEditLink", function (mediaIndex) {
      _this.handleMediaEditMenu(mediaIndex);
      _this.handleMediaCreatorPopup(mediaIndex);
    });
    _defineProperty(_this, "onDeleteLink", function (mediaIndex) {
      _this.handleMediaEditMenu(mediaIndex);
      _this.setState({
        mediaIndex: null
      }, function () {
        var newMediaList = _this.props.data.filter(function (mediaItem, index) {
          return index !== mediaIndex;
        });
        _this.props.onChange(newMediaList);
      });
    });
    _this.state = {
      newMediaCreatorOpen: false,
      showMoreIconIndex: null,
      mediaIndex: null,
      creatorOpen: false,
      editMenuOpen: false
    };
    return _this;
  }
  _inherits(Media, _Component);
  return _createClass(Media, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        disabled = _this$props2.disabled,
        labels = _this$props2.labels,
        recommendedMediaSizes = _this$props2.recommendedMediaSizes,
        images = _this$props2.images,
        readOnly = _this$props2.readOnly,
        isDescriptionEmpty = _this$props2.isDescriptionEmpty,
        videoPlatformAccepted = _this$props2.videoPlatformAccepted;
      var _this$state = this.state,
        newMediaCreatorOpen = _this$state.newMediaCreatorOpen,
        mediaIndex = _this$state.mediaIndex,
        creatorOpen = _this$state.creatorOpen,
        showMoreIconIndex = _this$state.showMoreIconIndex,
        editMenuOpen = _this$state.editMenuOpen;
      var mediaIcon = images.mediaIcon,
        disabledMediaIcon = images.disabledMediaIcon,
        badImageURL = images.badImageURL;
      var mediaLengthReached = R.length(data) >= 3;
      return /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMedia, {
        className: (0, _classnames["default"])({
          centered: readOnly && isDescriptionEmpty
        })
      }, newMediaCreatorOpen && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], _extends({
        componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
        onClose: this.handleNewMediaCreator,
        onChange: this.onCreateLink,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes
      }, _helpers.defaultMediaProps, {
        videoPlatformAccepted: videoPlatformAccepted
      })), !readOnly && /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMediaHandler, {
        onClick: this.handleNewMediaCreator,
        className: (0, _classnames["default"])({
          disabled: mediaLengthReached || disabled
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: mediaLengthReached || disabled ? disabledMediaIcon : mediaIcon,
        alt: "media",
        className: "media-helper-icon"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helper-text"
      }, labels.ADD_MEDIA)), !R.isEmpty(data) && !R.isNil(data) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "media-list"
      }, data.map(function (mediaItem, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _react["default"].createElement("div", {
            key: "".concat(mediaItem.alt, "-").concat(index)
          }, /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMediaContainer, {
            onMouseEnter: function onMouseEnter() {
              return _this2.onMouseEnterHandler(index);
            },
            onMouseLeave: _this2.onMouseLeaveHandler
          }, showMoreIconIndex === index && !disabled && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "more-icon icon-ion-android-more-vertical ",
            size: 24,
            onClick: function onClick() {
              return _this2.handleMediaEditMenu(index);
            }
          }), editMenuOpen && mediaIndex === index && /*#__PURE__*/_react["default"].createElement(_EditMenu["default"], {
            onClose: function onClose() {
              return _this2.handleMediaEditMenu(index);
            },
            onEdit: function onEdit() {
              return _this2.onEditLink(index);
            },
            onDelete: function onDelete() {
              return _this2.onDeleteLink(index);
            }
          }), creatorOpen && mediaIndex === index && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], _extends({
            componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
            onClose: _this2.handleMediaCreatorPopup,
            onChange: _this2.onCreateLink,
            labels: labels,
            videoPlatformAccepted: videoPlatformAccepted
          }, data[mediaIndex])), /*#__PURE__*/_react["default"].createElement(_MediaObject["default"], {
            type: mediaItem.type,
            src: mediaItem.src,
            alt: mediaItem.alt,
            readOnly: readOnly,
            imageFallback: badImageURL,
            recommendedMediaSizes: recommendedMediaSizes[_helpers.MEDIA_COMPONENTS.MEDIA]
          })), mediaItem.alt && /*#__PURE__*/_react["default"].createElement("p", {
            className: "media-title"
          }, mediaItem.alt))
        );
      })));
    }
  }]);
}(_react.Component);
Media.defaultProps = {
  data: [],
  readOnly: false,
  recommendedMediaSizes: {},
  isDescriptionEmpty: false,
  videoPlatformAccepted: []
};
Media.propTypes = {
  readOnly: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  labels: _propTypes["default"].shape({
    ADD_MEDIA: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  images: _propTypes["default"].shape({
    mediaIcon: _propTypes["default"].string,
    disabledMediaIcon: _propTypes["default"].string,
    badImageURL: _propTypes["default"].string
  }).isRequired,
  isDescriptionEmpty: _propTypes["default"].bool,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = exports["default"] = Media;